import { useEffect, useState } from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { getPuppies } from "../lib/api";

export default function Adopted() {
  const [puppies, setPuppies] = useState([]);

  useEffect(() => {
    getPuppies("adopted").then(setPuppies).catch(() => {});
  }, []);

  return (
    <div data-testid="adopted-page">
      <PageHero
        eyebrow="Happily Ever After"
        title={["Adopted &", "adored."]}
        subtitle="A gallery of the little ones who have already found their forever families. Every stamp is a story of love."
      />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {puppies.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <div data-testid={`adopted-card-${p.id}`} className="group">
                <div className="relative overflow-hidden rounded-md aspect-[4/5] bg-[#F5E6E3]">
                  <img src={p.images?.[0]} alt={p.name} className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
                  <div className="absolute inset-0 bg-[#2A2118]/30" />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="adopted-stamp px-8 py-3 text-3xl md:text-4xl font-medium">ADOPTED</span>
                  </div>
                </div>
                <div className="mt-4">
                  <h3 className="font-heading text-2xl text-[#2A2118]">{p.name}</h3>
                  <p className="text-sm text-[#8a7a68]">{p.breed}</p>
                  {p.description && <p className="text-sm text-[#5c5245] mt-2 font-light leading-relaxed">{p.description}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
